// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Collapsible } from './collapsible';
import { Component } from './component';

/**
 * @class Jsw.DropdownArea
 * @extends Jsw.Collapsible
 */
export const DropdownArea = Class.create(Collapsible, {
    _initComponentElement($super) {
        $super();
        this._componentElement.down(`#${this._anchorAreaId}`).update(
            `<h4><span>${this._getConfigParam('title', '')}</span></h4>`
        );
    },
});

/**
 * @class Jsw.DropdownSplit
 * @extends Jsw.Component
 */
export const DropdownSplit = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);
        this._cls = this._getConfigParam('cls', 'split');
    },
});

/**
 * @class Jsw.Dropdown
 * @extends Jsw.Collapsible
 */
export const Dropdown = Class.create(Collapsible, {
    _initConfiguration($super, config) {
        $super(config);
        this._valuesAreaId = `${this._id}-values-area`;
        this.onChange = this._getConfigParam('onChange', this.onChange);
    },

    _initComponentElement($super) {
        $super();
        this._componentElement.down(`#${this._contentAreaId}`).update(
            `<h4><span>${this._getConfigParam('title', '')}</span></h4>` +
            `<ul id="${this._valuesAreaId}"></ul>`
        );
    },

    _renderItem(item) {
        const dropdownItem = new DropdownItem(item);

        const valueItem = new Element('a').update(dropdownItem.title.escapeHTML());

        $(this._valuesAreaId).insert(
            new Element('li').update(valueItem)
        );

        valueItem.observe('click', this._onClick.bindAsEventListener(this, dropdownItem));
    },

    _onClick(event, item) {
        this.onChange(item);
    },

    onChange(item) {
        this.setValue(item.value);
    },

    setValue(value) {
        this._value = value;
    },

    getValue() {
        return this._value;
    },
});

/**
 * @class Jsw.DropdownItem
 */
export const DropdownItem = class {
    constructor(item) {
        if (Object.isString(item)) {
            this.value = item;
            this.title = item;
        } else {
            Object.extend(this, item);
        }
    }
};



// WEBPACK FOOTER //
// ./jsw/dropdown.js